<zui-theme-provider theme="dark">
    <ca-spinner></ca-spinner>

    <ng-sidebar-container *ngIf="!showFullscreen; else fullscreenTemplate">
        <ng-sidebar
            *ngIf="showSidebar"
            [(opened)]="isSidebarOpened"
            [closeOnClickOutside]="isSmallDevice"
            [mode]="sidebarMode"
            [animate]="showSidebar && isLoggedIn"
            [autoCollapseWidth]="_sidebarAutoCollapseWidth"
            dockedSize="100px"
            sidebarClass="sidebar"
            position="left"
        >
            <ca-sidebar-nav
                (openToggledChange)="toggleSidebarOpenState($event)"
                [isSmallDevice]="isSmallDevice"
                [isOpenToggled]="isSidebarOpened"
            ></ca-sidebar-nav>
        </ng-sidebar>

        <div ng-sidebar-content class="d-flex flex-column sidebar-content no-overflow-x">
            <section class="header-section">
                <ca-header (toggleSidebar)="toggleSidebarOpenState($event)"></ca-header>
            </section>
            <main [ngClass]="{ 'main-logged-out': !isLoggedIn }"><router-outlet></router-outlet></main>
            <section class="footer-section">
                <ca-footer *ngIf="isLoggedIn"></ca-footer>
                <ca-footer-landing *ngIf="!isLoggedIn && !isMEDProjectEnabled"></ca-footer-landing>
            </section>
            <ca-feedback-button *ngIf="isLoggedIn"></ca-feedback-button>
        </div>
    </ng-sidebar-container>

    <ng-template #fullscreenTemplate>
        <main class="fullscreen"><router-outlet></router-outlet></main>
        <ca-feedback-button *ngIf="isLoggedIn"></ca-feedback-button>
    </ng-template>
</zui-theme-provider>
